import type { ThemeProps } from './theme';

function hostnameFromUrl(url: string): string | null {
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
}

export function triggerRedirectIfRequired(theme: Pick<ThemeProps, 'redirectToUrl' | 'website'>): void {
  const currentHost = window.location.hostname;

  console.log('currentHost', currentHost);
  console.log('theme.redirectToUrl', theme.redirectToUrl);
  console.log('theme.website', theme.website);

  if (theme.redirectToUrl) {
    const redirectHost = hostnameFromUrl(theme.redirectToUrl);
    console.log('redirectHost', redirectHost);

    if (!redirectHost || redirectHost === currentHost) {
      console.log('do nothing 1');
      return;
    }
    
    window.location.href = theme.redirectToUrl;
    console.log('redirect to redirectToUrl');
    return;
  }

  if (!theme.website) {
    console.log('do nothing 2');
    return;
  }

  const websiteHost = hostnameFromUrl(theme.website);
  console.log('websiteHost', websiteHost);

  if (!websiteHost || websiteHost === currentHost) {
    console.log('do nothing 3');
    return;
  }

  console.log('redirect to website');
  window.location.href = theme.website;
}

